'use strict';

import './dastan.scss';

const review = [
  {
    "country": "Canada",
    "author": "Eyamos",
    "title": "یک پادکست فارسی خوب",
    "content": "یه پادکست فارسی خوب. داستانها جذابه و شنونده رو تا آخر با خودش میکشه. صدای خوب گوینده هم روی این جذابیت موثره",
    "rating": "5",
    "updated": "2018-07-26T10:27:34-07:00"
  },
  {
    "country": "United States",
    "author": "dr.ziz",
    "title": "سلااام",
    "content": "چرا اينقدر كم كاريد؟؟ وقتي كه خوبيد بايد بيشتر كار كنيد. حيفه اخه",
    "rating": "4",
    "updated": "2021-01-02T19:16:35-07:00"
  },
  {
    "country": "United States",
    "author": "AliDubber",
    "title": "ارشادی",
    "content": "ممنون از پادکست خوبتون. نویسنده راجع به همایون ارشادی و ماجرای کشفش توسط کیارستمی پشت ترافیک اشتباه کرده .. ایشون رو‌ تهمینه میلانی معرفی کرده و قبلش هم تجربه بازی داشته",
    "rating": "4",
    "updated": "2020-12-22T21:00:52-07:00"
  },
  {
    "country": "United States",
    "author": "Mina mostofi",
    "title": "زودتر بياييد",
    "content": "زود به زود بياييد وقتي خوبيد.",
    "rating": "5",
    "updated": "2020-11-14T23:35:31-07:00"
  },
  {
    "country": "United States",
    "author": "ماه شب",
    "title": "عالى",
    "content": "حيف كه انگار ديگه قصد ادامه نداريد. ولى هم روايتتون عاليه هم انتخاب داستانهاتون. ممنون",
    "rating": "5",
    "updated": "2020-10-13T18:00:15-07:00"
  },
  {
    "country": "United States",
    "author": "HannahVkn",
    "title": "🙃",
    "content": "کارتون عالیه واقعا لذت میبرم از شنیدن پادکستها فقط کاش یکم زود به زود منتشرشون کنین ❤️",
    "rating": "5",
    "updated": "2020-03-18T09:49:03-07:00"
  },
  {
    "country": "United States",
    "author": "b.taj",
    "title": "عالی عالی عالی...",
    "content": "عاشق کارتونم \nداستانهای منتخب، اجرای قوی شما و تسلطتون به کار بینظیر و تحسین برانگیزه 👏🏻👌🏻 \nفقط کاش فاصله بین اپیزودا کوتاهتر شه تا ما بیشتر از کاراتون لذت ببریم❤️",
    "rating": "5",
    "updated": "2019-10-30T16:30:29-07:00"
  },
  {
    "country": "United States",
    "author": "aboloverman",
    "title": "اپیزود گربه باز عالی بود",
    "content": "دروود بر شما ، امروز داشتم توی ترافیک همیشگی صبح داستان گر به باز رو با صدای شما گوش می دادم . نمی دونم واقعا این داستان کمدی بود یا نه ولی بارها با صدای بلند خندبدم و از تسلط شما در اجرا لذت بردم . ادامه بدین و اپیزودهای بیشتری با فاصله زمانی کمتر از یکماه پخش کنین . سپاس",
    "rating": "5",
    "updated": "2018-12-19T08:59:47-07:00"
  }
];

const fetch_reviews = async () => {
  const reviews_container = document.querySelector('.dastan__reviews-wrapper');
  let data;

  review.forEach(e => {
    if (e) {
      let jalali_date = new Date(e.updated).toLocaleDateString('fa-IR');
      let html =`
        <div class="review-container gf-markazi-style">
          <div class="review-rating"><img src="./${e.rating}.png"/></div>
          <div class="review-time">${jalali_date}</div>
          <div class="review-author">${e.author}</div>
          <h5 class="review-title">${e.title}</h5>
          <p class="review-content">${e.content}</p>
        </div>
      `;

    reviews_container.insertAdjacentHTML('beforeend', html);
    }

  })
}

fetch_reviews()
